<template>
  <div v-if="customPlansPage" class="section-min-width">
    <SlicesBlock :slices="slices" />
  </div>
  <Plans v-else :plans-page="true" />
</template>

<script>
import SlicesBlock from '@/components/Prismic/Landings/SlicesBlock.vue';
import Plans from 'Plans';

export default {
  nuxtI18n: {
    paths: {
      en: '/merch-plans/:keyword',
      de: '/merch-abos/:keyword',
      es: '/planes-merch/:keyword',
      pt: '/planos-merch/:keyword'
    }
  },
  components: {
    Plans,
    SlicesBlock
  },
  async asyncData({ $prismic, store }) {
    try {
      let languages = $prismic.api.data.languages;
      let language = languages.find((item) => item.id.indexOf(store.$i18n.locale) != -1);

      await store.dispatch('config/SEASONAL_STATUS');
      const isSeasonalActive = store.getters['config/isSeasonalActive'];
      const merchPlansUid = isSeasonalActive ? 'merch-plans-seasonal' : 'merch-plans';

      const result = await $prismic.api.getByUID('post', merchPlansUid, { lang: language.id });

      if (!result) {
        return {
          customPlansPage: false
        };
      }
      const pageConfiguration = result.data.body.find(
        (slice) => slice.slice_type === 'page_configuration'
      );
      if (pageConfiguration) {
        await store.dispatch('config/SET_PRISMIC_PAGE_CONFIGURATION', pageConfiguration.primary);
      }
      return {
        slices: result.data.body,
        customPlansPage: true
      };
    } catch (e) {
      return {
        customPlansPage: false
      };
    }
  },
  head() {
    const path = 'merch-plans';
    const params = {
      en: this.localePath(path, 'en'),
      es: this.localePath(path, 'es'),
      pt: this.localePath(path, 'pt'),
      de: this.localePath(path, 'de')
    };
    const hreflangs = this.$hrefLangPlugin(params, true);
    const canonicalLink = this.$trailingSlash(this.localePath(path));
    return {
      link: [
        {
          hid: 'i18n-can',
          href: canonicalLink,
          rel: 'canonical'
        },
        ...hreflangs
      ]
    };
  }
};
</script>
